import { useEffect, useRef } from 'react';
import { renderSuggestedCurrencyAutoSwitchToastOnce } from './ViewerContext';
export const SuggestedCurrencyAutoSwitchToastRenderer = _ref => {
  let {
    intent,
    shouldRenderToast = true
  } = _ref;
  const renderedIntentId = useRef();
  useEffect(() => {
    if (!shouldRenderToast) {
      return;
    }
    renderedIntentId.current = renderSuggestedCurrencyAutoSwitchToastOnce(intent, renderedIntentId.current);
  }, [intent, shouldRenderToast]);
  return null;
};
//# sourceMappingURL=SuggestedCurrencyAutoSwitchToastRenderer.js.map